import { render, staticRenderFns } from "./linchuangxinxi.vue?vue&type=template&id=a781ec68&scoped=true&"
import script from "./linchuangxinxi.vue?vue&type=script&lang=js&"
export * from "./linchuangxinxi.vue?vue&type=script&lang=js&"
import style0 from "./linchuangxinxi.vue?vue&type=style&index=0&id=a781ec68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a781ec68",
  null
  
)

export default component.exports